/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/ng-device-detector/ng-device-detector.d.ts" />

namespace Application.Controllers {
    'use strict';

    interface ILoginResponse {
        config?: {
            data?: {
                password?: string;
                username?: string;
            }
        };
    }

    /**
     * LoginController class
     */
    export class LoginController {
        public static $name: string = "loginController";
        public static $inject: string[] = ['$window',
                                           'loginService',
                                           '$rootScope',
                                           '$location',
                                           'backendService',
                                           '$cookies',
                                           'settingsService',
                                           '$timeout',
                                           'deviceDetector',
                                           '$http',
                                           ];
        public username: string;
        public password: string;
        public alertMsg: string;
        public authOptions: EurovisionControl.IRadioOption[] = [{value: "Cookie", selected: true}, {value: "Basic"}];
        public authType: EurovisionControl.IRadioOption;
        public isBrowserCompatible: boolean;
        public isNotFirefox: boolean;

        /**
         * Constructor
         */
        constructor(private $window: ng.IWindowService,
                    private loginService: Application.Services.LoginService,
                    private $rootScope: IFlexRootScope,
                    private $location: ng.ILocationService,
                    private backendService: Services.BackendService,
                    private $cookies: ng.cookies.ICookiesService,
                    private settingsService: Services.SettingsService,
                    private $timeout: ng.ITimeoutService,
                    private deviceDetector: ng.DeviceDetector,
                    private $http: ng.IHttpService) {
            this.initData();
            this.browserDetection();
        }

        public browserDetection(): void {
            this.isBrowserCompatible = navigator.userAgent.indexOf('HeadlessChrome') > -1 ||
                this.deviceDetector.browser === 'chrome' || this.deviceDetector.browser === 'firefox';
            // this.isNotFirefox = this.deviceDetector.browser !== 'firefox';
        }

        /**
         * Login process
         */
        public login(): void {
            this.updateCommitId(); // update commit ID to avoid cache issues
            if (this.authType && this.authType.value === 'Basic')
                return this.basicLogin();
            else
                return this.formLogin();
        }

        public basicLogin(): void {
            this.alertMsg = "";
            let returnPath: string = this.$location.search().returnPath !== '/logout' ? this.$location.search().returnPath : '';
            returnPath = returnPath ? returnPath : '/';
            this.loginService
                .login(this.username, this.password, returnPath);
        }

        public formLogin(): void {
            this.alertMsg = "";
            let returnPath: string = this.$location.search().returnPath !== '/logout' ? this.$location.search().returnPath : '';
            returnPath = returnPath && returnPath !== '/login' ? returnPath : '/';
            this.loginService.doFormLogin(this.username, this.password, returnPath)
                .then((resp: ILoginResponse) => {
                    this.loginService.isLoggedIn(undefined, true)
                        .then((response: ng.IHttpPromiseCallbackArg<boolean>) => {
                            if (response !== false) {
                                this.settingsService.setTheme();
                                this.$timeout(() => {
                                    window.location.href = this.getLocationWithReturnPath(returnPath);
                                    window.location.reload();
                                });
                            } else {
                                this.alertMsg = 'Wrong user and/or password';
                            }
                        }).catch(() => {
                            this.alertMsg = 'Wrong user and/or password';
                        });
                }).catch(() => {
                    this.alertMsg = 'Wrong user and/or password';
                });
        }

        /**
         * Initiliaze data
         */
        private initData(): void {
            this.$timeout(() => {
                window.altair_admin_common_init();
            }, 500);
            if (this.$location.path() === '/logout') {
                Common.Theme.setDefaultTheme();
                this.loginService.logout();
                this.$window.location.reload();
            } else if (this.$rootScope.vars.isUserLoggedIn) {
                this.$location.path('/');
            } else {
                Common.Theme.setDefaultTheme();
                this.username = '';
                this.password = '';
                this.alertMsg = '';
                let authData: string = this.$cookies.get(Services.LoginService.AUTH_HEADER_COOKIE_KEY);
                let returnPath: string = this.$location.search().returnPath;
                let login: string = this.$location.search().login;
                returnPath = returnPath ? returnPath : this.$location.path();
                if (authData !== undefined && authData !== '') {
                    this.loginService.directLogin(authData, returnPath);
                } else if (login !== undefined && login !== '') {
                    let password: string = this.$location.search().password;
                    this.loginService.doFormLogin(login, password, returnPath);
                }
            }
        }

        private updateCommitId(): void {
            this.$http.get('js/vars.js?t=' + new Date().getTime(), {headers:{'Cache-Control': 'no-cache'}})
                .then((value: ng.IHttpPromiseCallbackArg<{}>) => {
                const commitId: string = this.getValueFromVarsJs('commit', value.data as string);
                this.$rootScope.versionInfo = {
                    branch: "",
                    buildDate: "",
                    commit: commitId,
                };
            });
        }

        private getValueFromVarsJs(key: string, varsjs: string): string {
            const lastKeyIndex: number = varsjs.lastIndexOf(`${key}:"`);
            const varsjsSplitted: string[] = varsjs.substr(lastKeyIndex).split(`${key}:"`);
            const value: string = varsjsSplitted.length > 1 ? varsjsSplitted[1].split('"')[0] : "";
            return value;
        }
        
        private getLocationWithReturnPath(returnPath: string): string {
            return window.location.href.split('#!')[0] + '#!' + returnPath;
        }
    }
}
